import React from 'react'
import styled from 'styled-components'
import { ChipWrapper } from 'components/common/chip'
import {
  GradationTag,
  Tag,
  TagContainer,
  Tags,
  TagSize,
  TagType,
} from 'components/common/tag'
import { BoldText } from 'components/common/text'
import { NumberOrNull, Range } from 'types/common'
import { displayPositionName } from 'utils/displays'
import { getDiffFromPast } from 'utils/formatters'

export const StartupPositionItemSimpleInfo: React.FC<{
  position: {
    name: string
    careerType: string
    experienceRange: Range | null
    publishedAt: string
    averageReplyPeriod: NumberOrNull
    isSincerityReview: boolean
    techStacks: string[]
    isActivelyHireAds: boolean
  }
}> = ({ position }) => {
  return (
    <>
      <ChipWrapper>
        <BoldH5Text className='clickable' style={{ position: 'relative' }}>
          {displayPositionName(
            position.name,
            position.careerType,
            position.experienceRange || null,
          )}
        </BoldH5Text>
        {getDiffFromPast(position.publishedAt) < 8 && (
          <Tag variant={TagType.RED} size={TagSize.EXTRA_SMALL}>
            NEW
          </Tag>
        )}
        {position.isActivelyHireAds && (
          <GradationTag size={TagSize.EXTRA_SMALL}>적극 채용 중</GradationTag>
        )}
        {position.averageReplyPeriod !== null &&
          position.averageReplyPeriod <= 5 && (
            <Tag variant={TagType.BLUE} size={TagSize.EXTRA_SMALL}>
              빠른 응답
            </Tag>
          )}
        {position.isSincerityReview && (
          <Tag variant={TagType.BLUE} size={TagSize.EXTRA_SMALL}>
            성실 검토
          </Tag>
        )}
      </ChipWrapper>
      <TagContainer style={{ maxHeight: 68, overflow: 'hidden' }}>
        <Tags data={position.techStacks} />
      </TagContainer>
    </>
  )
}

const BoldH5Text = styled(BoldText)`
  font-size: ${(p) => p.theme.fontSize.h5};
`
